export default __webpack_public_path__ + "static/media/ball.527145ef.mp3";